
const CalcType = {
  Account: 'Account',
  Benchmark: 'Benchmark',
  Relative: 'Relative',
};

export default CalcType;

export const calcTypeOptions = Object.values(CalcType).map(val => ({ label: val, value: val }));

